import React from 'react'
import axios from 'axios'
import Autocomplete from '@material-ui/lab/Autocomplete'
import TextField from '@material-ui/core/TextField'
import { Bootstrap2Toggle } from 'react-bootstrap-toggle'
import { countryToFlag } from '../../lib/format-dmps'



/* Adform Country and Agency selection */
export default class AdformRights extends React.Component {
    state = {
        countries: [],
        agencies: [],
        agenciesFiltered: [],
        selectAllAgencies: true,
    }

    componentDidMount() {
        console.log('adform rights filter props: ', this.props)
        this.loadCountries()
        this.loadAgencies()
    }

    loadCountries() {
        axios.get('/adform/countries').then(response => {
            //console.log('adform countries list', response.data.body)

            // remove countries without iso2code, they are useless
            this.setState({
                countries: response.data.body
                    .filter(c => c.hasOwnProperty('iso2Code'))
                    .sort((a, b) => {
                        var keyA = a.name,
                            keyB = b.name
                        if (keyA < keyB) return -1
                        if (keyA > keyB) return 1
                        return 0
                    })
            })
        })
    }

    loadAgencies() {
        axios.get('/adform/agencies').then(response => {
            //console.log('adform agencies list', response.data.body)
            this.setState({ agencies: response.data.body })
        })
    }

    onCountryChange(countryId, isoCode) {
        let agenciesFiltered = this.state.agencies
            .filter(c => c.countryId == countryId)
            .sort((a, b) => {
                var keyA = a.name,
                    keyB = b.name
                if (keyA < keyB) return -1
                if (keyA > keyB) return 1
                return 0
            })
        agenciesFiltered.unshift({id: 'ADF_A_' + isoCode + '_' + countryId, name: 'Select All'})


        this.setState(
            {
                agenciesFiltered: agenciesFiltered
            },
            () => {
                console.log('agencies filtered ', this.state.agenciesFiltered)
            }
        )
    }

    render() {
        return (
            <div className="row">
                <div className={'col-2'}>
                    <div>
                        <p style={{whiteSpace: 'nowrap', marginTop: 30 }}>Select All Countries</p>

                            <Bootstrap2Toggle
                                id="active"
                                onClick={value => {
                                    let selectAllAgencies = this.state.selectAllAgencies
                                    this.setState({selectAllAgencies: !selectAllAgencies})
                                    this.props.onAgencyChange('ADF_AC')
                                }}
                                on={<span>YES</span>}
                                off={<span>NO</span>}
                                size="xs"
                                offstyle="secondary"
                                active={this.state.selectAllAgencies}
                            />

                    </div>
                </div>

                    <div className={'col-4'}>
                        <div>
                            <p style={{ marginTop: 30 }}>Country</p>

                            {this.state.countries && (
                                <Autocomplete
                                    disabled={this.state.selectAllAgencies}
                                    id="country-select"
                                    options={this.state.countries}
                                    autoHighlight
                                    getOptionLabel={option => option.name}
                                    onChange={(event, newValue) => {
                                        if (newValue) {
                                            console.log('country change ', newValue)
                                            this.onCountryChange(newValue.id, newValue.iso2Code)
                                            this.props.onCountryChange(newValue.id)
                                        }
                                    }}
                                    renderOption={option => (
                                        <React.Fragment>
                                            <span>{countryToFlag(option.iso2Code)}</span>&#160;{option.name}
                                        </React.Fragment>
                                    )}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            label="Choose a country"
                                            variant="outlined"
                                            inputProps={{
                                                ...params.inputProps,
                                                autoComplete: 'new-password', // disable autocomplete and autofill
                                                form: {
                                                    autocomplete: 'off'
                                                }
                                            }}
                                        />
                                    )}
                                />
                            )}
                        </div>
                    </div>
                    <div className="col-6">
                        <div>
                            <p style={{ marginTop: 30 }}>Agency</p>

                            {this.state.agencies && this.state.agenciesFiltered && (
                                <Autocomplete
                                    disabled={this.state.selectAllAgencies}
                                    id="agency-select"
                                    options={this.state.agenciesFiltered}
                                    autoHighlight
                                    getOptionLabel={option => option.name}
                                    onChange={(event, newValue) => {
                                        if (newValue) this.props.onAgencyChange(newValue.id)
                                    }}
                                    renderOption={option => <React.Fragment>{option.name}</React.Fragment>}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            label="Choose an Agency"
                                            variant="outlined"
                                            inputProps={{
                                                ...params.inputProps,
                                                autoComplete: 'new-password', // disable autocomplete and autofill
                                                form: {
                                                    autocomplete: 'off'
                                                }
                                            }}
                                        />
                                    )}
                                />
                            )}
                        </div>
                        
                    </div>
                      
                      
                </div>
                
        )
    }
}
